import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';
import TIMER_LINE from '@ifit/react-icons/dist/icons/TIMER_LINE';
import DISTANCE_LINE from '@ifit/react-icons/dist/icons/DISTANCE_LINE';
import CALORIE_BURN_LINE from '@ifit/react-icons/dist/icons/CALORIE_BURN_LINE';
import ELEVATION_GAIN_LINE from '@ifit/react-icons/dist/icons/ELEVATION_GAIN_LINE';
import PACE_LINE from '@ifit/react-icons/dist/icons/PACE_LINE';
import FIT_SCORE_LINE from '@ifit/react-icons/dist/icons/FIT_SCORE_LINE';
import INTENSITY_LINE from '@ifit/react-icons/dist/icons/INTENSITY_LINE';
import WorkoutIcon from '../workout-icon';

const PostWorkoutStats = ({ mediaType, sharedWorkout, unitSystem }) => {
  function getEffortScore(activityLog) {
    const stats = activityLog.stats || {};
    const value = stats.xScore && stats.xScore.length ? stats.xScore[stats.xScore.length - 1].value : 0; // cumulative stat
    const roundedValue = Math.floor(value);
    return roundedValue;
  }

  function totalDistanceSR(totalDistance) {
    if (totalDistance === 1) {
      return I18n.translate('mile', 'Standard unit of measurement');
    } else {
      return I18n.translate('miles', 'Standard unit of measurement');
    }
  }

  const { activityLog } = sharedWorkout;
  const { summary: { totalElevationGain, totalMeters, totalCalories }, stats: { xScore } } = activityLog;
  const { duration } = activityLog;
  const totalDistance = (totalMeters * 0.00062137).toFixed(2);
  const pace = Math.floor(duration / totalDistance);
  const burnedCalories = Math.round(totalCalories);
  const elevationGain = Math.round(totalElevationGain * 3.2808);
  const workoutType = sharedWorkout.workout.type;
  const intensity = sharedWorkout.workout.difficulty;

  return (
    <div className="stats-section">
      <ul>
        { duration !== undefined &&
          <WorkoutIcon
            icon={ TIMER_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Time in minutes.', context: 'Header describing an user workout duration.' }) }
            titleDescription={ ({ text: 'Time (min)', context: 'A title telling the user\'s time during the work out.' }) }
            stat={ ({ text: duration, ariaLabel: duration }) }
            showAsTime={ true }
            system={ unitSystem }
          />
        }
        { totalMeters !== undefined && workoutType !== 'strength' &&
          <WorkoutIcon
            icon={ DISTANCE_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Distance in miles.', context: 'Header describing an user workout distance.' }) }
            titleDescription={ ({ text: 'Distance (MI)', context: 'A title telling the user\'s distance in miles during the work out.' }) }
            stat={ ({ text: totalDistance, ariaLabel: totalDistanceSR(totalDistance) }) }
            system={ unitSystem }
          />
        }
        { totalCalories !== undefined &&
          <WorkoutIcon
            icon={ CALORIE_BURN_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Estimated calories burned.', context: 'Header describing an calories burned during an exercise.' }) }
            titleDescription={ ({ text: 'Est Burn (cals)', context: 'A title telling the estimated calories the user burned during the work out. Cals = Calories.' }) }
            stat={ ({ text: burnedCalories, ariaLabel: 'calories', desc: 'Unit for burning energy.' }) }
            system={ unitSystem }
          />
        }
        { totalElevationGain !== undefined && workoutType !== 'strength' && workoutType !== 'row' &&
          <WorkoutIcon
            icon={ ELEVATION_GAIN_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Elevation gain in feet.', context: `Header describing an user workout\'s gain in elevation in ${ unitSystem } measurement.` }) }
            titleDescription={ ({ text: 'Elevation Gain (FT)', context: 'A title telling the user\'s elevation gain in feet during the work out.' }) }
            stat={ ({ text: elevationGain, ariaLabel: 'feet', desc: `Length measurement in ${ unitSystem } units.` }) }
            system={ unitSystem }
          />
        }
        { totalMeters !== undefined && workoutType !== 'strength' &&
          <WorkoutIcon
            icon={ PACE_LINE }
            mediaType={ mediaType }
            ariaLabelDescription={ ({ text: 'Average pace in minutes per mile.', context: 'Header describing an user\'s walking or running pace during a workout.' }) }
            titleDescription={ ({ text: 'Avg Pace (Min/Mi)', context: 'A title telling the user\'s average pace in minutes per mile during the work out.' }) }
            stat={ ({ text: pace, ariaLabel: pace }) }
            showAsTime={ true }
            system={ unitSystem }
          />
        }
        { xScore !== undefined && workoutType !== 'strength' &&
          <WorkoutIcon
            icon={ FIT_SCORE_LINE }
            mediaType={ mediaType }
            titleDescription={ ({ text: 'Effort Score', context: 'A title telling the user\'s effort score during the work out.' }) }
            stat={ ({ text: getEffortScore(activityLog) }) }
            system={ unitSystem }
          />
        }
        { workoutType === 'strength' &&
          <WorkoutIcon
            icon={ INTENSITY_LINE }
            mediaType={ mediaType }
            titleDescription={ ({ text: 'Intensity', context: 'A title containing the intensity of the user\'s work out.' }) }
            stat={ ({ text: `${ intensity }/7`, desc: 'Sentence fragment giving an intensity rating out of 7. Ex. "1/7."' }) }
            system={ unitSystem }
          />
        }
      </ul>
    </div>
  );
};

PostWorkoutStats.propTypes = {
  mediaType: PropTypes.string.isRequired,
  sharedWorkout: PropTypes.object.isRequired,
  unitSystem: PropTypes.string
};

const ConnectPostWorkoutStats = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    layout: state.layout
  };
})(PostWorkoutStats);

export default ConnectPostWorkoutStats;